<template>
  <div class="chart-container donut">
    <div v-if="!chartData">
      <b-alert variant="warning" show>No data found for the selected options</b-alert>
    </div>
    <div class="chart" :style="chartStyle">
      <canvas :id="elementId"></canvas>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import Chart from '@/lib/mixins/Chart'

export default {
  mixins: [Chart],
  name: 'StackedBarChart',
  props: ['results', 'options', 'legendPosition'],
  components: { },
  data () {
    return {
      itemLinks: {},
      chartType: 'bar',
      chartOptions: {
        legend: { display: true, position: this.legendPosition || 'right' },
        scales: {
          xAxes: [{
            stacked: true,
            type: 'category',
            scaleLabel: {
              display: false,
              labelString: 'Y'
            },
            ticks: {
              autoSkip: true,
              autoSkipPadding: 10.5,
              minRotation: 90,
              maxRotation: 90
            }
          }],
          yAxes: [{
            stacked: true,
            type: 'linear',
            scaleLabel: {
              display: false,
              labelString: 'Y'
            },
            ticks: {
              min: 0,
              maxTicksLimit: 5,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label
                }
              }
            }
          }]
        }
      }
    }
  },
  computed: {
    chartJsData () {
      return {
        labels: this.chartData.labels,
        datasets: this.chartData.datasets
      }
    }
  },
  watch: {
    results: {
      immediate: true,
      handler (oldVal, newVale) {
        this.update()
      }
    },
    options: {
      immediate: true,
      handler (oldVal, newVal) {
        this.update()
      }
    },
    chartData: {
      immediate: true,
      handler (oldVal, newVal) {
        this.draw()
      }
    }
  },
  methods: {
    update () {
      if (this.results != null && this.results.rows.length > 0) {
        var labelColumn = this.results.columns[0]
        var stackColumn = this.results.columns[1]
        var valueColumn = this.results.columns[this.results.columns.length - 1]
        this.chartOptions.scales.xAxes[0].scaleLabel = { display: true, labelString: labelColumn.name }
        this.chartOptions.scales.yAxes[0].scaleLabel = { display: true, labelString: valueColumn.name }

        const labels = _.uniq(this.results.rows.map((row) => row[labelColumn.key]))
        var stackValues = this.results.rows.filter((row) => { return row[valueColumn.key] > 0 }).map((row) => row[stackColumn.key]).sort()
        stackValues = _.uniqBy(stackValues, (v) => { return v.toString().toLowerCase() })

        var rowsByLabel = {}
        this.itemLinks = []
        this.results.rows.forEach((row) => {
          const label = row[labelColumn.key]
          const stackValue = row[stackColumn.key].toString().toLowerCase()
          if (rowsByLabel[label] == null) {
            rowsByLabel[label] = {}
          }
          rowsByLabel[label][stackValue] = row[valueColumn.key]

          const labelIndex = labels.indexOf(label)
          const stackIndex = _.findIndex(stackValues, (v) => { return v.toString().toLowerCase() === stackValue })
          if (this.itemLinks[labelIndex] == null) {
            this.itemLinks[labelIndex] = []
          }
          this.itemLinks[labelIndex][stackIndex] = row.link
        })

        var datasets = []
        stackValues.forEach((stackValue, index) => {
          const data = labels.map((label) => {
            return rowsByLabel[label][stackValue.toString().toLowerCase()]
          })
          datasets.push({
            label: stackValue,
            data: data,
            backgroundColor: this.color(index)
          })
        })

        this.chartData = {
          labels: labels,
          datasets: datasets
        }
      } else {
        this.chartData = null
        this.itemLinks = []
      }
    },
    clickChart (event, item) {
      if (item.length > 0) {
        const datasetIndex = item[0]._datasetIndex
        const index = item[0]._index
        if (this.itemLinks[index] != null) {
          const link = this.itemLinks[index][datasetIndex]
          this.selectLink(link)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StackedBarChart.vue